import { type FC, useCallback } from 'react';
import { useInterval } from 'usehooks-ts';
import { triggerReload } from '../model';
import { useStore } from '../store';
import { useAutoReloadIsEnabled } from '../utils/useCanAutoReload';

export const EventReloadManager: FC = () => {
  const eventId = useStore((state) => state.eventId);
  const reloadInterval = useStore((state) => state.events.at(0)?.options.reloadInterval ?? 0);
  const canAutoReload = useAutoReloadIsEnabled();

  const handleReload = useCallback(async () => {
    if (!canAutoReload) return;

    try {
      await triggerReload(eventId);
    } catch (err) {
      console.error('Failed to reload event info:', err);
    }
  }, [eventId, canAutoReload]);

  useInterval(handleReload, canAutoReload ? reloadInterval : null);

  return null;
};
